'use client';

import { useTranslations } from 'next-intl';
import {
  CatButton,
  CatInlineNotification,
  CatIconWarningTriangleFilled
} from 'components/blocks-components';
import cx from 'classnames';
import style from './video-warning.module.scss';

type VideoWarningProps = {
  classname?: string;
  isproduct?: boolean;
};

const VideoWarning = ({ classname, isproduct }: VideoWarningProps) => {
  const t = useTranslations();

  const handleOpenCookieSettingsDrawer = () => {
    if (typeof window?.OptanonWrapper === 'function') {
      window?.Optanon.ToggleInfoDisplay();
    }
  };

  return (
    <div
      className={cx(
        't-0',
        classname,
        style[
          `${isproduct ? 'product-image-picker-video-warning' : 'product-list-tab-video-warning'}`
        ]
      )}
      data-testid="cookie-warning-message"
    >
      <CatInlineNotification variant="warning" heading={t('COOKIES_REQUIRED')}>
        <CatIconWarningTriangleFilled slot="before" />
        <p className="mb-lg-3 mb-sm-0 mb-xs-3">
          {t('COOKIES_WATCH_VIDEOS_ACCEPT')}
        </p>

        <div slot="after">
          <CatButton
            className="ot-sdk-show-settings"
            onClick={handleOpenCookieSettingsDrawer}
          >
            {t('COOKIE_SETTINGS')}
          </CatButton>
        </div>
      </CatInlineNotification>
    </div>
  );
};

export default VideoWarning;
